module.exports = __webpack_public_path__ + "img/StorageSpaces.a0939a86.svg";